import { makeAutoObservable } from 'mobx'

interface $DialogButton {
  title: string
  onClick?: () => void
}

export interface $DialogData {
  title: string
  body?: string
  buttons?: Array<$DialogButton>
  open: boolean
  important?: boolean
  wordBreak?: 'break-all' | 'keep-all' | 'normal'
}

export default class UiStore {
  toastData = {
    message: '',
    open: false,
    type: 'message',
  }
  dialogData: $DialogData = {
    title: '',
    body: '',
    open: false,
    important: false,
    buttons: [],
  }
  toastTimer: NodeJS.Timeout | null = null
  document: string | null = null
  documentModalVisible = false

  constructor() {
    makeAutoObservable(this)
  }

  showToast = (message: string, type?: string) => {
    this.toastData.open = true
    this.toastData.message = message
    this.toastData.type = type || 'message'

    if (this.toastTimer) clearTimeout(this.toastTimer)

    this.toastTimer = setTimeout(this.hideToast, 4000)
  }

  hideToast = () => {
    this.toastTimer && clearTimeout(this.toastTimer)
    this.toastData.message = ''
    this.toastTimer = null
    this.toastData.open = false
  }

  showDocumentModal = (document: string) => {
    this.document = document
    this.documentModalVisible = true
  }

  hideDocumentModal = () => {
    this.documentModalVisible = false
    this.document = null
  }
}

export type $UiStore = UiStore